import React, { useState, useEffect, useRef, useCallback } from 'react'
import { Retrieve_personal_info, iconwrapper } from '../../../../../../config/commonfunctions'
import { ILOOKUPTEMPLATESINFO_MAP, INVITATIONTYPES_ARR, TABLET, INVITATION_COUPLE_DEFAULT_IMGS_MAP } from '../../../../../../config/constants'
import { S3CLOUD_CLOUDFRONT_ASSET } from '../../../../../../config/s3directories'
import { TICK_ICON, WEDO_PATH, HEART_PATH, LAPTOP_ICON, TABLET_ICON } from '../../../../../../config/svgicons'
import { inputdescribe_dom, partialtitle_dom, radiobtn_dom } from '../Commonelements/Commonelements'
import { Modcfm, Noti, getCroppedImg } from '../../../../../../components'
import { INVITATION_SAVEHEROIMGS } from '../../../../../../config/api'
import Highlighttitle from '../Highlighttitle/Highlighttitle'
import { HexColorInput, HexColorPicker } from 'react-colorful'
import Explain from './../Explain'
import axios from 'axios'
import Cropper from 'react-easy-crop'
import './Templates.css'

const TEMPLATE_CARDPAGE = 1
const TEMPLATE_FULLPAGE = 2

const colors_arr = ['#333333', '#707070', '#e1d9ca', '#7b5c5c']

const getUniqueThumbnails = (imageMap) => {
    const thumbnailsSet = new Set();
    Object.values(imageMap).forEach(images => {
        images.forEach(image => {
            if (image.thumbnail) {
                thumbnailsSet.add(image.thumbnail);
            }
        });
    });
    return Array.from(thumbnailsSet);
};

const getUniqueImgs = (imageMap) => {
    const imgSet = new Set();
    Object.values(imageMap).forEach(images => {
        images.forEach(image => {
            if (image.img) {
                imgSet.add(image.img);
            }
        });
    });
    return Array.from(imgSet);
};

const ALL_UNIQUE_DEFAULT_COUPLE_THUMBNAILS = getUniqueThumbnails(INVITATION_COUPLE_DEFAULT_IMGS_MAP)
const ALL_UNIQUE_DEFAULT_COUPLE_IMGS = getUniqueImgs(INVITATION_COUPLE_DEFAULT_IMGS_MAP)

var Imagedownsize = (img, type) => {
    var canvas = document.createElement('canvas');
    var ctx1 = canvas.getContext("2d");
    ctx1.drawImage(img, 0, 0);
    var dataurl
    if (type === 'logo') {
        var MAX_WIDTH = 450;
        var MAX_HEIGHT = 450;
        var width = img.width;
        var height = img.height;

        if (width > height) { // this will adjust in ratio
            if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width;
                width = MAX_WIDTH;
            }
        } else {
            if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height;
                height = MAX_HEIGHT;
            }
        }
        canvas.width = width;
        canvas.height = height;
        var ctx2 = canvas.getContext("2d");
        ctx2.drawImage(img, 0, 0, width, height)
        dataurl = canvas.toDataURL("image/png")
    }
    return dataurl
}

const dataURLToBlob = function (dataURL) {
    var BASE64_MARKER = ';base64,';
    if (dataURL.indexOf(BASE64_MARKER) === -1) {
        var parts1 = dataURL.split(',');
        var contentType1 = parts1[0].split(':')[1];
        var raw1 = parts1[1];
        return new Blob([raw1], { type: contentType1 });
    }

    var parts = dataURL.split(BASE64_MARKER);
    var contentType = parts[0].split(':')[1];
    var raw = window.atob(parts[1]);
    var rawLength = raw.length;

    var uInt8Array = new Uint8Array(rawLength);

    for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
    }

    return new Blob([uInt8Array], { type: contentType });
}

const selected_css = '3px solid var(--mainpink)'
const unselected_css = '1px solid transparent' // rgb(218, 218, 218)
const imagecolor = 'rgb(214, 214, 214)'
const TITLE = 'Templates'
const TEXT = `Select different template and background color for your event invtitation. We have currently 2 different templates for you to choose from.`

const prebuilttemplatest1 = [
    {
        name: 'Amaryllis Purpurea',
        templatecolors: ['#FFFFF8', '#fcf8e8', '#fcf5e3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFFFF8': S3CLOUD_CLOUDFRONT_ASSET + 'prebuilttemplate/smaller/Amaryllis_Purpurea.png',
            '#fcf8e8': S3CLOUD_CLOUDFRONT_ASSET + 'prebuilttemplate/smaller/Amaryllis_Purpurea.png',
            '#fcf5e3': S3CLOUD_CLOUDFRONT_ASSET + 'prebuilttemplate/smaller/Amaryllis_Purpurea.png',
        },
        templatecolors_data_map: { // data based on template color
            '#FFFFF8': { "menustyle": { "backgroundColor": "#FFFFF8", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#FFFFF8", "fc": "#333333", },
            '#fcf8e8': { "menustyle": { "backgroundColor": "#fcf8e8", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#fcf8e8", "fc": "#333333", },
            "#fcf5e3": { "menustyle": { "backgroundColor": "#fcf5e3", "color": "#292e2f", "borderColor": "#292e2f" }, "templatecolor": "#fcf5e3", "fc": "#292e2f" }
        },
        svgoverlay_map: {
            '#FFFFF8': { mainimg: { svgitem: 1, mode: 2, color: "#FFFFF8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#fcf8e8': { mainimg: { svgitem: 1, mode: 2, color: "#fcf8e8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#fcf5e3': { mainimg: { svgitem: 1, mode: 2, color: "#fcf5e3", replay: true, speed: 0, svgposition: 2, sw: 45 } }
        },
        common_data: {
            "ntm": 0,
            "ntt": 1,
            "ntw": 1,
            "ffobj": {
                "priff": "Montserrat",
                "secff": "Cormorant Upright"
            },
            "styleborder": 4,
            "stylebordercolor": "#c8c09e",
            "styleborderbr": true,
            "styleborderwt": false,
            "styletype": "Amaryllis_Purpurea",
            "styleorientationmobile": 0,
            "styleorientation": 0,
            "styleformationmobile": 0,
            "styleformation": 2,
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Amaryllis_Purpurea/banner/banner.png`,
        },
    },
    {
        name: 'Blanket Flower',
        templatecolors: ['#FFF7EE', '#fcf8e8',],
        templatecolors_data_map: {
            "#FFF7EE": { "menustyle": { "backgroundColor": "#FFF7EE", "color": "#292e2f", "borderColor": "#292e2f" }, "templatecolor": "#FFF7EE", "fc": "#292e2f" },
            "#fcf8e8": { "menustyle": { "backgroundColor": "#fcf8e8", "color": "#292e2f", "borderColor": "#292e2f" }, "templatecolor": "#fcf8e8", "fc": "#292e2f" },
        },
        templatecolors_img_map: {
            '#FFF7EE': S3CLOUD_CLOUDFRONT_ASSET + 'prebuilttemplate/smaller/Blanket_Flower.png',
            '#fcf8e8': S3CLOUD_CLOUDFRONT_ASSET + 'prebuilttemplate/smaller/Blanket_Flower.png',
        },
        svgoverlay_map: {
            '#FFF7EE': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7EE", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#fcf8e8': { mainimg: { svgitem: 1, mode: 2, color: "#fcf8e8", replay: true, speed: 0, svgposition: 2, sw: 45 } }
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1, "ffobj": { "priff": "Montserrat", "secff": "Dancing Script" }, "styleborder": 4, "stylebordercolor": "#c8c09e", "styleborderbr": true, "styleborderwt": false, "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Blanket_Flower/banner/banner.png`, "styletype": "Blanket_Flower", "styleorientationmobile": 0, "styleformationmobile": 0, "styleorientation": 0, "styleformation": 2,
        },
    },
    {
        name: 'Damask Rose',
        templatecolors: ['#2a3044', '#293462'],
        templatecolors_data_map: {
            "#2a3044": { "menustyle": { "backgroundColor": "#2a3044", "color": "#ffeec7", "borderColor": "#ffeec7" }, "templatecolor": "#2a3044", "fc": "#ffeec7" },
            "#293462": { "menustyle": { "backgroundColor": "#293462", "color": "#FEB139", "borderColor": "#FEB139" }, "templatecolor": "#293462", "fc": "#FEB139" }
        },
        templatecolors_img_map: {
            "#2a3044": S3CLOUD_CLOUDFRONT_ASSET + 'prebuilttemplate/smaller/Damask_Rose.png',
            "#293462": S3CLOUD_CLOUDFRONT_ASSET + 'prebuilttemplate/smaller/Damask_Rose.png',
        },
        svgoverlay_map: {
            '#2a3044': { mainimg: { svgitem: 1, mode: 2, color: "#ffeec7", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#293462': { mainimg: { svgitem: 1, mode: 2, color: "#FEB139", replay: true, speed: 0, svgposition: 2, sw: 45 } }
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1, "ffobj": { "priff": "Montserrat", "secff": "Dancing Script" }, "styleborder": 4, "stylebordercolor": "#c8c09e", "styleborderbr": true, "styleborderwt": false, "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Rosa_Gallica/banner/banner.png`, "styletype": "Rosa_Gallica", "styleorientationmobile": 0, "styleformationmobile": 0, "styleorientation": 0, "styleformation": 0,
        },
    },
    {
        name: 'Red Epidendrum',
        templatecolors: ['#FFFFF8',],
        templatecolors_data_map: {
            "#FFFFF8": { "menustyle": { "backgroundColor": "#FFFFF8", "color": "#535648", "borderColor": "#535648" }, "templatecolor": "#FFFFF8", "fc": "#535648" }
        },
        templatecolors_img_map: {
            "#FFFFF8": S3CLOUD_CLOUDFRONT_ASSET + 'prebuilttemplate/smaller/Red_Epidendrum.png',
        },
        svgoverlay_map: {
            '#FFFFF8': { mainimg: { svgitem: 1, mode: 2, color: "#FFFFF8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1, "ffobj": { "priff": "Montserrat", "secff": "Parisienne" }, "styleborder": 4, "stylebordercolor": "#c8c09e", "styleborderbr": true, "styleborderwt": false, "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Red_Epidendrum/banner/banner.png`, "styletype": "Red_Epidendrum", "styleorientationmobile": 0, "styleformationmobile": 0, "styleorientation": 0, "styleformation": 2,
        },
    },
    {
        name: 'Mexican Poppy',
        templatecolors: ['#FFE6C7', '#fcf8e8', '#FFFFF8'],
        templatecolors_data_map: {
            "#FFE6C7": { "menustyle": { "backgroundColor": "#FFE6C7", "color": "#454545", "borderColor": "#454545" }, "templatecolor": "#FFE6C7", "fc": "#454545" },
            "#fcf8e8": { "menustyle": { "backgroundColor": "#FFFFF8", "color": "#454545", "borderColor": "#454545" }, "templatecolor": "#fcf8e8", "fc": "#454545" },
            "#FFFFF8": { "menustyle": { "backgroundColor": "#FFFFF8", "color": "#454545", "borderColor": "#454545" }, "templatecolor": "#FFFFF8", "fc": "#454545" }
        },
        templatecolors_img_map: {
            "#FFE6C7": S3CLOUD_CLOUDFRONT_ASSET + 'prebuilttemplate/smaller/Mexican_Poppy.png',
            "#fcf8e8": S3CLOUD_CLOUDFRONT_ASSET + 'prebuilttemplate/smaller/Mexican_Poppy.png',
            "#FFFFF8": S3CLOUD_CLOUDFRONT_ASSET + 'prebuilttemplate/smaller/Mexican_Poppy.png',
        },
        svgoverlay_map: {
            '#FFE6C7': { mainimg: { svgitem: 1, mode: 2, color: "#FFE6C7", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#fcf8e8': { mainimg: { svgitem: 1, mode: 2, color: "#fcf8e8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFFFF8': { mainimg: { svgitem: 1, mode: 2, color: "#FFFFF8", replay: true, speed: 0, svgposition: 2, sw: 45 } }
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1, "ffobj": { "priff": "Montserrat", "secff": "Dancing Script" }, "styleborder": 2, "stylebordercolor": "#c8c09e", "styleborderbr": true, "styleborderwt": false, "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Mexican_Poppy/banner/banner.png`, "styletype": "Mexican_Poppy", "styleorientationmobile": 0, "styleformationmobile": 0, "styleorientation": 0, "styleformation": 2,
        },
    },
    {
        name: 'Crimson Damask',
        templatecolors: ['#FAF5E4'],
        templatecolors_data_map: {
            "#FAF5E4": { "menustyle": { "backgroundColor": "#FAF5E4", "color": "#125B50", "borderColor": "#125B50" }, "templatecolor": "#FAF5E4", "fc": "#125B50" }
        },
        templatecolors_img_map: {
            "#FAF5E4": S3CLOUD_CLOUDFRONT_ASSET + 'prebuilttemplate/smaller/Crimson_Damask.png',
        },
        svgoverlay_map: {
            '#FAF5E4': { mainimg: { svgitem: 1, mode: 2, color: "#FAF5E4", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1, "ffobj": { "priff": "Montserrat", "secff": "Dancing Script" }, "styleborder": 4, "stylebordercolor": "#c8c09e", "styleborderbr": true, "styleborderwt": false, "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Crimson_Damask/banner/banner.png`, "styletype": "Crimson_Damask", "styleorientationmobile": 0, "styleformationmobile": 0, "styleorientation": 0, "styleformation": 0,
        },
    },
    {
        name: 'Gilia Flexuosa',
        templatecolors: ['#FFFFF8'],
        templatecolors_data_map: {
            "#FFFFF8": { "menustyle": { "backgroundColor": "#FFFFF8", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#FFFFF8", "fc": "#333333" }
        },
        templatecolors_img_map: {
            "#FFFFF8": S3CLOUD_CLOUDFRONT_ASSET + 'prebuilttemplate/smaller/Gilia_Flexuosa.png',
        },
        svgoverlay_map: {
            '#FFFFF8': { mainimg: { svgitem: 1, mode: 2, color: "#FFFFF8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1, "ffobj": { "priff": "Montserrat", "secff": "Kaushan Script" }, "styleborder": 4, "stylebordercolor": "#c8c09e", "styleborderbr": true, "styleborderwt": false, "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Slender_Flowered_Gilia/banner/banner.png`, "styletype": "Slender_Flowered_Gilia", "styleorientationmobile": 0, "styleformationmobile": 0, "styleorientation": 3, "styleformation": 2,
        },
    }
]

const prebuilttemplatest2 = [
    {
        name: 'De Candolle Rose',
        templatecolors: ['#FFFFF8', '#fcf8e8', '#faf4f4'],
        templatecolors_img_map: { // img showing based on template color
            '#FFFFF8': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/De_Candolle_Rose_T2.png`,
            '#fcf8e8': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/De_Candolle_Rose_T2.png`,
            '#faf4f4': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/De_Candolle_Rose_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFFFF8': { "menustyle": { "backgroundColor": "#FFFFF8", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#FFFFF8", "fc": "#333333", },
            '#fcf8e8': { "menustyle": { "backgroundColor": "#fcf8e8", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#fcf8e8", "fc": "#333333", },
            '#faf4f4': { "menustyle": { "backgroundColor": "#faf4f4", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#faf4f4", "fc": "#333333", },
        },
        svgoverlay_map: {
            '#FFFFF8': { mainimg: { svgitem: 1, mode: 2, color: "#FFFFF8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#fcf8e8': { mainimg: { svgitem: 1, mode: 2, color: "#fcf8e8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#faf4f4': { mainimg: { svgitem: 1, mode: 2, color: "#faf4f4", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "De_Candolle_Rose",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/De_Candolle_Rose/banner/banner.png`,
        },
    },
    {
        name: 'Bloom Collection',
        templatecolors: ['#FFFFF8', '#fcf8e8', '#faf4f4'],
        templatecolors_img_map: { // img showing based on template color
            '#FFFFF8': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Bloom_Collection_T2.png`,
            '#fcf8e8': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Bloom_Collection_T2.png`,
            '#faf4f4': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Bloom_Collection_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFFFF8': { "menustyle": { "backgroundColor": "#FFFFF8", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#FFFFF8", "fc": "#333333", },
            '#fcf8e8': { "menustyle": { "backgroundColor": "#fcf8e8", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#fcf8e8", "fc": "#333333", },
            '#faf4f4': { "menustyle": { "backgroundColor": "#faf4f4", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#faf4f4", "fc": "#333333", },
        },
        svgoverlay_map: {
            '#FFFFF8': { mainimg: { svgitem: 1, mode: 2, color: "#FFFFF8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#fcf8e8': { mainimg: { svgitem: 1, mode: 2, color: "#fcf8e8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#faf4f4': { mainimg: { svgitem: 1, mode: 2, color: "#faf4f4", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Bloom_Collection",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Bloom_Collection/banner/banner.png`,
        },
    },
    {
        name: 'Phlox Amoena',
        templatecolors: ['#FFFFF8', '#fcf8e8', '#faf4f4'],
        templatecolors_img_map: { // img showing based on template color
            '#FFFFF8': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Phlox_Amoena_T2.png`,
            '#fcf8e8': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Phlox_Amoena_T2.png`,
            '#faf4f4': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Phlox_Amoena_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFFFF8': { "menustyle": { "backgroundColor": "#FFFFF8", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#FFFFF8", "fc": "#333333", },
            '#fcf8e8': { "menustyle": { "backgroundColor": "#fcf8e8", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#fcf8e8", "fc": "#333333", },
            '#faf4f4': { "menustyle": { "backgroundColor": "#faf4f4", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#faf4f4", "fc": "#333333", },
        },
        svgoverlay_map: {
            '#FFFFF8': { mainimg: { svgitem: 1, mode: 2, color: "#FFFFF8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#fcf8e8': { mainimg: { svgitem: 1, mode: 2, color: "#fcf8e8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#faf4f4': { mainimg: { svgitem: 1, mode: 2, color: "#faf4f4", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Phlox_Amoena",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Phlox_Amoena/banner/banner.png`,
        },
    },
    {
        name: 'Azalea',
        templatecolors: ['#FFFFF8', '#fcf8e8', '#faf4f4'],
        templatecolors_img_map: { // img showing based on template color
            '#FFFFF8': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Azalea_T2.png`,
            '#fcf8e8': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Azalea_T2.png`,
            '#faf4f4': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Azalea_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFFFF8': { "menustyle": { "backgroundColor": "#FFFFF8", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#FFFFF8", "fc": "#333333", },
            '#fcf8e8': { "menustyle": { "backgroundColor": "#fcf8e8", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#fcf8e8", "fc": "#333333", },
            '#faf4f4': { "menustyle": { "backgroundColor": "#faf4f4", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#faf4f4", "fc": "#333333", },
        },
        svgoverlay_map: {
            '#FFFFF8': { mainimg: { svgitem: 1, mode: 2, color: "#FFFFF8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#fcf8e8': { mainimg: { svgitem: 1, mode: 2, color: "#fcf8e8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#faf4f4': { mainimg: { svgitem: 1, mode: 2, color: "#faf4f4", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Azalea",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Azalea/banner/banner.png`,
        },
    },
    {
        name: 'White Paradise',
        templatecolors: ['#FFFFF8', '#fcf8e8', '#faf4f4'],
        templatecolors_img_map: { // img showing based on template color
            '#FFFFF8': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/White_Paradise_T2.png`,
            '#fcf8e8': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/White_Paradise_T2.png`,
            '#faf4f4': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/White_Paradise_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFFFF8': { "menustyle": { "backgroundColor": "#FFFFF8", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#FFFFF8", "fc": "#333333", },
            '#fcf8e8': { "menustyle": { "backgroundColor": "#fcf8e8", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#fcf8e8", "fc": "#333333", },
            '#faf4f4': { "menustyle": { "backgroundColor": "#faf4f4", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#faf4f4", "fc": "#333333", },
        },
        svgoverlay_map: {
            '#FFFFF8': { mainimg: { svgitem: 1, mode: 2, color: "#FFFFF8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#fcf8e8': { mainimg: { svgitem: 1, mode: 2, color: "#fcf8e8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#faf4f4': { mainimg: { svgitem: 1, mode: 2, color: "#faf4f4", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "White_Paradise",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/White_Paradise/banner/banner.png`,
        },
    },
    {
        name: 'Rosa Candolleana Elegans',
        templatecolors: ['#FFFFF8', '#fcf8e8', '#faf4f4'],
        templatecolors_img_map: { // img showing based on template color
            '#FFFFF8': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Rosa_Candolleana_Elegans_T2.png`,
            '#fcf8e8': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Rosa_Candolleana_Elegans_T2.png`,
            '#faf4f4': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Rosa_Candolleana_Elegans_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFFFF8': { "menustyle": { "backgroundColor": "#FFFFF8", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#FFFFF8", "fc": "#333333", },
            '#fcf8e8': { "menustyle": { "backgroundColor": "#fcf8e8", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#fcf8e8", "fc": "#333333", },
            '#faf4f4': { "menustyle": { "backgroundColor": "#faf4f4", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#faf4f4", "fc": "#333333", },
        },
        svgoverlay_map: {
            '#FFFFF8': { mainimg: { svgitem: 1, mode: 2, color: "#FFFFF8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#fcf8e8': { mainimg: { svgitem: 1, mode: 2, color: "#fcf8e8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#faf4f4': { mainimg: { svgitem: 1, mode: 2, color: "#faf4f4", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Rosa_Candolleana_Elegans",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Rosa_Candolleana_Elegans/banner/banner.png`,
        },
    },
    {
        name: 'Rosa_Indica_Caryophyllea',
        templatecolors: ['#FFFFF8', '#fcf8e8', '#faf4f4'],
        templatecolors_img_map: { // img showing based on template color
            '#FFFFF8': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Rosa_Indica_Caryophyllea_T2.png`,
            '#fcf8e8': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Rosa_Indica_Caryophyllea_T2.png`,
            '#faf4f4': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Rosa_Indica_Caryophyllea_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFFFF8': { "menustyle": { "backgroundColor": "#FFFFF8", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#FFFFF8", "fc": "#333333", },
            '#fcf8e8': { "menustyle": { "backgroundColor": "#fcf8e8", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#fcf8e8", "fc": "#333333", },
            '#faf4f4': { "menustyle": { "backgroundColor": "#faf4f4", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#faf4f4", "fc": "#333333", },
        },
        svgoverlay_map: {
            '#FFFFF8': { mainimg: { svgitem: 1, mode: 2, color: "#FFFFF8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#fcf8e8': { mainimg: { svgitem: 1, mode: 2, color: "#fcf8e8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#faf4f4': { mainimg: { svgitem: 1, mode: 2, color: "#faf4f4", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Rosa_Indica_Caryophyllea",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Rosa_Indica_Caryophyllea/banner/banner.png`,
        },
    },
    {
        name: 'Rosa Multiflora Carnea',
        templatecolors: ['#FFFFF8', '#fcf8e8', '#faf4f4'],
        templatecolors_img_map: { // img showing based on template color
            '#FFFFF8': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Rosa_Multiflora_Carnea_T2.png`,
            '#fcf8e8': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Rosa_Multiflora_Carnea_T2.png`,
            '#faf4f4': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Rosa_Multiflora_Carnea_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFFFF8': { "menustyle": { "backgroundColor": "#FFFFF8", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#FFFFF8", "fc": "#333333", },
            '#fcf8e8': { "menustyle": { "backgroundColor": "#fcf8e8", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#fcf8e8", "fc": "#333333", },
            '#faf4f4': { "menustyle": { "backgroundColor": "#faf4f4", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#faf4f4", "fc": "#333333", },
        },
        svgoverlay_map: {
            '#FFFFF8': { mainimg: { svgitem: 1, mode: 2, color: "#FFFFF8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#fcf8e8': { mainimg: { svgitem: 1, mode: 2, color: "#fcf8e8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#faf4f4': { mainimg: { svgitem: 1, mode: 2, color: "#faf4f4", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Rosa_Multiflora_Carnea",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Rosa_Multiflora_Carnea/banner/banner.png`,
        },
    },
    {
        name: 'Red Epidendrum',
        templatecolors: ['#FFFFF8', '#fcf8e8', '#faf4f4'],
        templatecolors_img_map: { // img showing based on template color
            '#FFFFF8': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Red_Epidendrum_T2.png`,
            '#fcf8e8': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Red_Epidendrum_T2.png`,
            '#faf4f4': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Red_Epidendrum_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFFFF8': { "menustyle": { "backgroundColor": "#FFFFF8", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#FFFFF8", "fc": "#333333", },
            '#fcf8e8': { "menustyle": { "backgroundColor": "#fcf8e8", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#fcf8e8", "fc": "#333333", },
            '#faf4f4': { "menustyle": { "backgroundColor": "#faf4f4", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#faf4f4", "fc": "#333333", },
        },
        svgoverlay_map: {
            '#FFFFF8': { mainimg: { svgitem: 1, mode: 2, color: "#FFFFF8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#fcf8e8': { mainimg: { svgitem: 1, mode: 2, color: "#fcf8e8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#faf4f4': { mainimg: { svgitem: 1, mode: 2, color: "#faf4f4", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Red_Epidendrum",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Red_Epidendrum/banner/banner.png`,
        },
    },
    {
        name: 'Epidendrum Polyanthum',
        templatecolors: ['#fff4e0', '#FFFFF8', '#fcf8e8', '#faf4f4'],
        templatecolors_img_map: { // img showing based on template color
            '#fff4e0': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Epidendrum_Polyanthum_T2.png`,
            '#FFFFF8': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Epidendrum_Polyanthum_T2.png`,
            '#fcf8e8': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Epidendrum_Polyanthum_T2.png`,
            '#faf4f4': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Epidendrum_Polyanthum_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#fff4e0': { "menustyle": { "backgroundColor": "#fff4e0", "color": "#e77471", "borderColor": "#e77471" }, "templatecolor": "#e77471", "fc": "#e77471", },
            '#FFFFF8': { "menustyle": { "backgroundColor": "#FFFFF8", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#FFFFF8", "fc": "#333333", },
            '#fcf8e8': { "menustyle": { "backgroundColor": "#fcf8e8", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#fcf8e8", "fc": "#333333", },
            '#faf4f4': { "menustyle": { "backgroundColor": "#faf4f4", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#faf4f4", "fc": "#333333", },
        },
        svgoverlay_map: {
            '#fff4e0': { mainimg: { svgitem: 1, mode: 2, color: "#fff4e0", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFFFF8': { mainimg: { svgitem: 1, mode: 2, color: "#FFFFF8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#fcf8e8': { mainimg: { svgitem: 1, mode: 2, color: "#fcf8e8", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#faf4f4': { mainimg: { svgitem: 1, mode: 2, color: "#faf4f4", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Epidendrum_Polyanthum",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Epidendrum_Polyanthum/banner/banner.png`,
        },
    },
    {
        name: 'Plum Blossoms',
        templatecolors: ['#708871'],
        templatecolors_img_map: { // img showing based on template color
            '#708871': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Plum_Blossoms_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#708871': { "menustyle": { "backgroundColor": "#708871", "color": "#FEF3E2", "borderColor": "#FEF3E2" }, "templatecolor": "#FEF3E2", "fc": "#FEF3E2", },
        },
        svgoverlay_map: {
            '#708871': { mainimg: { svgitem: 1, mode: 2, color: "#708871", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Plum_Blossoms",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Plum_Blossoms/banner/banner.png`,
        },
    },
    {
        name: 'Rosa Banksiae',
        templatecolors: ['#FFF7EE'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7EE': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Rosa_Banksiae_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7EE': { "menustyle": { "backgroundColor": "#FFF7EE", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
        },
        svgoverlay_map: {
            '#FFF7EE': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7EE", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Rosa_Banksiae",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Rosa_Banksiae/banner/banner.png`,
        },
    },
    {
        name: 'Paperwhites',
        templatecolors: ['#FFF7EE'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7EE': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Paperwhites_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7EE': { "menustyle": { "backgroundColor": "#FFF7EE", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
        },
        svgoverlay_map: {
            '#FFF7EE': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7EE", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Paperwhites",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Paperwhites/banner/banner.png`,
        },
    },
    {
        name: 'White Wild Rose',
        templatecolors: ['#FEFFE2', '#E8DFCA'],
        templatecolors_img_map: { // img showing based on template color
            '#FEFFE2': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/White_Wild_Rose_T2.png`,
            '#E8DFCA': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/White_Wild_Rose_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FEFFE2': { "menustyle": { "backgroundColor": "#FEFFE2", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#E8DFCA': { "menustyle": { "backgroundColor": "#E8DFCA", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
        },
        svgoverlay_map: {
            '#FEFFE2': { mainimg: { svgitem: 1, mode: 2, color: "#FEFFE2", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#E8DFCA': { mainimg: { svgitem: 1, mode: 2, color: "#E8DFCA", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "White_Wild_Rose",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/White_Wild_Rose/banner/banner.png`,
        },
    },
    {
        name: 'Purple Mallow',
        templatecolors: ['#FFFBF5', '#fdf7f1', '#f6e2f0'],
        templatecolors_img_map: { // img showing based on template color
            '#FFFBF5': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Purple_Mallow_T2.png`,
            '#fdf7f1': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Purple_Mallow_T2.png`,
            '#f6e2f0': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Purple_Mallow_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFFBF5': { "menustyle": { "backgroundColor": "#FFFBF5", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#fdf7f1': { "menustyle": { "backgroundColor": "#fdf7f1", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#f6e2f0': { "menustyle": { "backgroundColor": "#f6e2f0", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
        },
        svgoverlay_map: {
            '#FFFBF5': { mainimg: { svgitem: 1, mode: 2, color: "#FFFBF5", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#fdf7f1': { mainimg: { svgitem: 1, mode: 2, color: "#fdf7f1", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#f6e2f0': { mainimg: { svgitem: 1, mode: 2, color: "#f6e2f0", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Purple_Mallow",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Purple_Mallow/banner/banner.png`,
        },
    },
    {
        name: 'Chinese Primula',
        templatecolors: ['#fdf7f1', '#ffe5e5'],
        templatecolors_img_map: { // img showing based on template color
            '#fdf7f1': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Chinese_Primula_T2.png`,
            '#ffe5e5': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Chinese_Primula_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#fdf7f1': { "menustyle": { "backgroundColor": "#fdf7f1", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#ffe5e5': { "menustyle": { "backgroundColor": "#ffe5e5", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
        },
        svgoverlay_map: {
            '#fdf7f1': { mainimg: { svgitem: 1, mode: 2, color: "#fdf7f1", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#ffe5e5': { mainimg: { svgitem: 1, mode: 2, color: "#ffe5e5", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Chinese_Primula",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Chinese_Primula/banner/banner.png`,
        },
    },
    {
        name: 'Apple Blossom',
        templatecolors: ['#fdf7f1', '#ffe5e5'],
        templatecolors_img_map: { // img showing based on template color
            '#fdf7f1': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Apple_Blossom_T2.png`,
            '#ffe5e5': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Apple_Blossom_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#fdf7f1': { "menustyle": { "backgroundColor": "#fdf7f1", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#ffe5e5': { "menustyle": { "backgroundColor": "#ffe5e5", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
        },
        svgoverlay_map: {
            '#fdf7f1': { mainimg: { svgitem: 1, mode: 2, color: "#fdf7f1", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#ffe5e5': { mainimg: { svgitem: 1, mode: 2, color: "#ffe5e5", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Apple_Blossom",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Apple_Blossom/banner/banner.png`,
        },
    },
    {
        name: 'Forget Not Me',
        templatecolors: ['#fdf7f1', '#ffe5e5'],
        templatecolors_img_map: { // img showing based on template color
            '#fdf7f1': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Forget_Not_Me_T2.png`,
            '#ffe5e5': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Forget_Not_Me_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#fdf7f1': { "menustyle": { "backgroundColor": "#fdf7f1", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#ffe5e5': { "menustyle": { "backgroundColor": "#ffe5e5", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
        },
        svgoverlay_map: {
            '#fdf7f1': { mainimg: { svgitem: 1, mode: 2, color: "#fdf7f1", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#ffe5e5': { mainimg: { svgitem: 1, mode: 2, color: "#ffe5e5", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Forget_Not_Me",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Forget_Not_Me/banner/banner.png`,
        },
    },
    {
        name: 'Bluets',
        templatecolors: ['#FDFAF6', '#FFF2F2'],
        templatecolors_img_map: { // img showing based on template color
            '#FDFAF6': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Bluets_T2.png`,
            '#FFF2F2': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Bluets_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FDFAF6': { "menustyle": { "backgroundColor": "#FDFAF6", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF2F2': { "menustyle": { "backgroundColor": "#FFF2F2", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FDFAF6': { mainimg: { svgitem: 1, mode: 2, color: "#FDFAF6", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF2F2': { mainimg: { svgitem: 1, mode: 2, color: "#FFF2F2", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Bluets",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Bluets/banner/banner.png`,
        },
    },
    {
        name: 'Jacob Ladder',
        templatecolors: ['#FDFAF6', '#FFF2F2'],
        templatecolors_img_map: { // img showing based on template color
            '#FDFAF6': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Jacob_Ladder_T2.png`,
            '#FFF2F2': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Jacob_Ladder_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FDFAF6': { "menustyle": { "backgroundColor": "#FDFAF6", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF2F2': { "menustyle": { "backgroundColor": "#FFF2F2", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FDFAF6': { mainimg: { svgitem: 1, mode: 2, color: "#FDFAF6", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF2F2': { mainimg: { svgitem: 1, mode: 2, color: "#FFF2F2", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Jacob_Ladder",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Jacob_Ladder/banner/banner.png`,
        },
    },
    {
        name: 'Bearberry',
        templatecolors: ['#FDFAF6', '#FFF2F2'],
        templatecolors_img_map: { // img showing based on template color
            '#FDFAF6': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Bearberry_T2.png`,
            '#FFF2F2': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Bearberry_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FDFAF6': { "menustyle": { "backgroundColor": "#FDFAF6", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF2F2': { "menustyle": { "backgroundColor": "#FFF2F2", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FDFAF6': { mainimg: { svgitem: 1, mode: 2, color: "#FDFAF6", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF2F2': { mainimg: { svgitem: 1, mode: 2, color: "#FFF2F2", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Bearberry",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Bearberry/banner/banner.png`,
        },
    },
    {
        name: 'Rose Gentian',
        templatecolors: ['#F8F8E1', '#FFF7F3', '#FFF6E3', '#E0FBE2'],
        templatecolors_img_map: { // img showing based on template color
            '#F8F8E1': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Rose_Gentian_T2.png`,
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Rose_Gentian_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Rose_Gentian_T2.png`,
            '#E0FBE2': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Rose_Gentian_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#F8F8E1': { "menustyle": { "backgroundColor": "#F8F8E1", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
            '#E0FBE2': { "menustyle": { "backgroundColor": "#E0FBE2", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#F8F8E1': { mainimg: { svgitem: 1, mode: 2, color: "#F8F8E1", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#E0FBE2': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Rose_Gentian",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Rose_Gentian/banner/banner.png`,
        },
    },
    {
        name: 'Lisianthus',
        templatecolors: ['#F8F8E1', '#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#F8F8E1': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Lisianthus_T2.png`,
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Lisianthus_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Lisianthus_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#F8F8E1': { "menustyle": { "backgroundColor": "#F8F8E1", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#F8F8E1': { mainimg: { svgitem: 1, mode: 2, color: "#F8F8E1", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Lisianthus",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Lisianthus/banner/banner.png`,
        },
    },
    {
        name: 'Fringed Gentian',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Fringed_Gentian_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Fringed_Gentian_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Fringed_Gentian",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Fringed_Gentian/banner/banner.png`,
        },
    },
    {
        name: 'Gilia Arizonica',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Gilia_Arizonica_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Gilia_Arizonica_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Gilia_Arizonica",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Gilia_Arizonica/banner/banner.png`,
        },
    },
    {
        name: 'Marsh Marigold',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Marsh_Marigold_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Marsh_Marigold_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Marsh_Marigold",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Marsh_Marigold/banner/banner.png`,
        },
    },
    {
        name: 'Greenstem Paperflower',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Greenstem_Paperflower_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Greenstem_Paperflower_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Greenstem_Paperflower",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Greenstem_Paperflower/banner/banner.png`,
        },
    },
    {
        name: 'Purple Monkey Flower',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Purple_Monkey_Flower_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Purple_Monkey_Flower_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Purple_Monkey_Flower",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Purple_Monkey_Flower/banner/banner.png`,
        },
    },
    {
        name: 'Scarlet Globe Mallow',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Scarlet_Globe_Mallow_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Scarlet_Globe_Mallow_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Scarlet_Globe_Mallow",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Scarlet_Globe_Mallow/banner/banner.png`,
        },
    },
    {
        name: 'Thicket Hawthorn',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Thicket_Hawthorn_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Thicket_Hawthorn_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Thicket_Hawthorn",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Thicket_Hawthorn/banner/banner.png`,
        },
    },
    {
        name: 'Vervain',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Vervain_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Vervain_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Vervain",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Vervain/banner/banner.png`,
        },
    },
    {
        name: 'Zinnia',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Zinnia_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Zinnia_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Zinnia",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Zinnia/banner/banner.png`,
        },
    },
    {
        name: 'Wild Hyacinth',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Wild_Hyacinth_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Wild_Hyacinth_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Wild_Hyacinth",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Wild_Hyacinth/banner/banner.png`,
        },
    },

    {
        name: 'Wild Sweet Crab',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Wild_Sweet_Crab_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Wild_Sweet_Crab_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Wild_Sweet_Crab",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Wild_Sweet_Crab/banner/banner.png`,
        },
    },
    {
        name: 'Flower Luxe',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Flower_Luxe_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Flower_Luxe_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Flower_Luxe",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Flower_Luxe/banner/banner.png`,
        },
    },
    {
        name: 'Wildflower Charm',
        templatecolors: ['#E7EFC7', '#AEC8A4', '#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#E7EFC7': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Wildflower_Charm_T2.png`,
            '#AEC8A4': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Wildflower_Charm_T2.png`,
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Wildflower_Charm_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Wildflower_Charm_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#E7EFC7': { "menustyle": { "backgroundColor": "#E7EFC7", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#AEC8A4': { "menustyle": { "backgroundColor": "#AEC8A4", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#E7EFC7': { mainimg: { svgitem: 1, mode: 2, color: "#E7EFC7", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#AEC8A4': { mainimg: { svgitem: 1, mode: 2, color: "#AEC8A4", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF6E3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Wildflower_Charm",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Wildflower_Charm/banner/banner.png`,
        },
    },
    {
        name: 'Viscaria Vulgaris',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Viscaria_Vulgaris_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Viscaria_Vulgaris_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Viscaria_Vulgaris",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Viscaria_Vulgaris/banner/banner.png`,
        },
    },
    {
        name: 'Tuberose',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Tuberose_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Tuberose_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Tuberose",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Tuberose/banner/banner.png`,
        },
    },
    {
        name: 'Tetrandrous Condollea',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Tetrandrous_Condollea_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Tetrandrous_Condollea_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Tetrandrous_Condollea",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Tetrandrous_Condollea/banner/banner.png`,
        },
    },
    {

        name: 'Almond Blossom',
        templatecolors: ['#FEF9F2', '#FFEFEF', '#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FEF9F2': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Almond_Blossom_T2.png`,
            '#FFEFEF': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Almond_Blossom_T2.png`,
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Almond_Blossom_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Almond_Blossom_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FEF9F2': { "menustyle": { "backgroundColor": "#FEF9F2", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFEFEF': { "menustyle": { "backgroundColor": "#FFEFEF", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FEF9F2': { mainimg: { svgitem: 1, mode: 2, color: "#FEF9F2", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFEFEF': { mainimg: { svgitem: 1, mode: 2, color: "#FFEFEF", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Almond_Blossom",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Almond_Blossom/banner/banner.png`,
        },
    },
    {
        name: 'Apple Blossoms',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Apple_Blossoms_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Apple_Blossoms_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Apple_Blossoms",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Apple_Blossoms/banner/banner.png`,
        },
    },
    {
        name: 'Apricot Flower',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Apricot_Flower_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Apricot_Flower_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Apricot_Flower",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Apricot_Flower/banner/banner.png`,
        },
    },
    {
        name: 'Ruellia Brittoniana',
        templatecolors: ['#FFF2EB', '#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF2EB': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Ruellia_Brittoniana_T2.png`,
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Ruellia_Brittoniana_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Ruellia_Brittoniana_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF2EB': { "menustyle": { "backgroundColor": "#FFF2EB", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF2EB': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Ruellia_Brittoniana",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Ruellia_Brittoniana/banner/banner.png`,
        },
    },
    {
        name: 'Sea Lavender',
        templatecolors: ['#FFF2EB', '#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF2EB': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Sea_Lavender_T2.png`,
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Sea_Lavender_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Sea_Lavender_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF2EB': { "menustyle": { "backgroundColor": "#FFF2EB", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF2EB': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Sea_Lavender",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Sea_Lavender/banner/banner.png`,
        },
    },
    {
        name: 'Shewy Aster',
        templatecolors: [ '#C7D9DD', '#D5E5D5', '#EEF1DA', '#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#C7D9DD': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Shewy_Aster_T2.png`,
            '#D5E5D5': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Shewy_Aster_T2.png`,
            '#EEF1DA': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Shewy_Aster_T2.png`,
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Shewy_Aster_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Shewy_Aster_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#C7D9DD': { "menustyle": { "backgroundColor": "#C7D9DD", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#D5E5D5': { "menustyle": { "backgroundColor": "#D5E5D5", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#EEF1DA': { "menustyle": { "backgroundColor": "#EEF1DA", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#C7D9DD': { mainimg: { svgitem: 1, mode: 2, color: "#C7D9DD", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#D5E5D5': { mainimg: { svgitem: 1, mode: 2, color: "#D5E5D5", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#EEF1DA': { mainimg: { svgitem: 1, mode: 2, color: "#EEF1DA", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Shewy_Aster",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Shewy_Aster/banner/banner.png`,
        },
    },
    {
        name: 'Spartium Junceum',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Spartium_Junceum_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Spartium_Junceum_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Spartium_Junceum",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Spartium_Junceum/banner/banner.png`,
        },
    },
    {
        name: 'Aster',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Aster_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Aster_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Aster",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Aster/banner/banner.png`,
        },
    },
    {
        name: 'California Poppy',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/California_Poppy_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/California_Poppy_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "California_Poppy",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/California_Poppy/banner/banner.png`,
        },
    },
    {
        name: 'Canchalagua',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Canchalagua_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Canchalagua_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Canchalagua",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Canchalagua/banner/banner.png`,
        },
    },
    {
        name: 'Cliff Rose',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Cliff_Rose_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Cliff_Rose_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Cliff_Rose",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Cliff_Rose/banner/banner.png`,
        },
    },
    {
        name: 'Fragrant Devotion',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Fragrant_Devotion_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Fragrant_Devotion_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Fragrant_Devotion",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Fragrant_Devotion/banner/banner.png`,
        },
    },
    {
        name: 'Spring Harmony',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Spring_Harmony_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Spring_Harmony_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Spring_Harmony",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Spring_Harmony/banner/banner.png`,
        },
    },
    {
        name: 'Syringa',
        templatecolors: ['#FFF7F3', '#FFF6E3'],
        templatecolors_img_map: { // img showing based on template color
            '#FFF7F3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Syringa_T2.png`,
            '#FFF6E3': `${S3CLOUD_CLOUDFRONT_ASSET}prebuilttemplate/smaller/Syringa_T2.png`,
        },
        templatecolors_data_map: { // data based on template color
            '#FFF7F3': { "menustyle": { "backgroundColor": "#FFF7F3", "color": "#333333", "borderColor": "#333333" }, "templatecolor": "#333333", "fc": "#333333", },
            '#FFF6E3': { "menustyle": { "backgroundColor": "#FFF6E3", "color": "#2D336B", "borderColor": "#2D336B" }, "templatecolor": "#2D336B", "fc": "#2D336B", },
        },
        svgoverlay_map: {
            '#FFF7F3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
            '#FFF6E3': { mainimg: { svgitem: 1, mode: 2, color: "#FFF7F3", replay: true, speed: 0, svgposition: 2, sw: 45 } },
        },
        common_data: {
            "ntm": 0, "ntt": 1, "ntw": 1,
            "ffobj": { "priff": "Montserrat", "secff": "Cormorant Upright" },
            "styletype": "Syringa",
            "sep": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Syringa/banner/banner.png`,
        },
    },
]

function Templates(props) {
    const {
        firsttimeenter, updateTemplate, restoreBackup, updateBackup, saveTemplates, clearBackup, selectedTemplate,
        itype, wt, device, urlhandler, updatePrebuilttemplateT1, updatePrebuilttemplateT2, invitation_id,
        heroimglayout, heroimglayout_map, updateHeroimglayout, updateheroimgobj, delsingleheroimgobj, updateSubpageback,
        selectedsubpage, updateSelectedsubpage, heroimgattr_map, updateHeroimgattrmap,
        saveprompt,
        templateattr_map, updateTemplateattrmap,
        prebuildtemplatedesign_map
    } = props

    const [firsttime, setFirsttime] = useState(true)
    const [selectedtemplatetype, setSelectedtemplatetype] = useState(null)
    const [localselectedtemplatetype, setLocalselectedtemplatetype] = useState(null)
    const [selectedlayout, setSelectedlayout] = useState('')
    const [showsave, setShowsave] = useState(false) // indicate save activate, when user make any savable actions.
    const [DEVICE_SIZE_MAP, setDEVICE_SIZE_MAP] = useState({})
    const [status, setStatus] = useState('')
    const [error, setError] = useState('')

    const [prebuildtemplatecolor, setPrebuildtemplatecolor] = useState({
        1: '',
        2: '',
    })
    const [prebuildindex, setPrebuildindex] = useState({
        1: -1, // templatetype : template selected index
        2: -1
    })

    // for cropping image
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [tempmainimg, setTempmainimg] = useState(null)
    const [tempmainimgsmall, setTempmainimgsmall] = useState(null)
    const [tempmainimginfo, setTempmainimginfo] = useState(null)
    const [tempcroppedimg, setTempcroppedimg] = useState(null)

    const [uploadstate, setUploadstate] = useState('WAITING') // WAITING, UPLOADING

    const [neededit, setNeededit] = useState(false)

    // delete image mod
    const [deleteimgposition, setDeleteimgposition] = useState(-1)
    const [cfmdel, setCfmdel] = useState(false)

    const [selecteddevice, setSelecteddevice] = useState(-1) // 0:WEB || 1:MOBILE

    const { token } = Retrieve_personal_info()

    const [heroimgarrposition, setHeroimgarrposition] = useState(-1) // position to be send to backend to indicate the change upload img position
    const imginputref = useRef(null)

    const commoneditstyle = {
        height: {
            'WEB': 'calc(100% - 70px - 65px)',
            'TABLET': 'calc(100% - 70px - 65px)',
            'MOBILE': 'calc(100% - 70px)'
        }[device],
        marginBottom: {
            'MOBILE': 65
        }[device]
    }

    const homeimageeffectstyle_commoneditstyle = {
        height: {
            'WEB': 'calc(100% - 70px - 65px)',
            'TABLET': 'calc(100% - 70px - 65px)',
            'MOBILE': 'calc(100% - 70px)'
        }[device],
        marginBottom: {
            'MOBILE': 65
        }[device]
    }

    const firsttimeenter_commoneditstyle = {
        height: {
            'WEB': 'calc(100% - 61px  - 65px )',
            'TABLET': 'calc(100% - 70px - 65px)',
            'MOBILE': 'calc(100% - 70px)'
        }[device],
        marginBottom: {
            'MOBILE': 65
        }[device]
    }

    const wtfactor_w = (0.45 * 0.25)
    const wtfactor_t = (0.45 * 0.3333)
    const wtfactor_m = 0.5

    const webconst = `calc( ${wt * wtfactor_w}px - 18px )`
    const tabletconst = `calc( ${wt * wtfactor_t}px - 20px )`
    const mobileconst = `calc( ${wt * wtfactor_m}px - 20px )`

    useEffect(() => {
        setDEVICE_SIZE_MAP({
            'WEB': { minHeight: webconst, minWidth: webconst, maxHeight: webconst, maxWidth: webconst, fontSize: 32, borderRadius: 10, },
            'TABLET': { minHeight: tabletconst, minWidth: tabletconst, maxHeight: tabletconst, maxWidth: tabletconst, fontSize: 32, borderRadius: 10, },
            'MOBILE': { minHeight: mobileconst, minWidth: mobileconst, maxHeight: mobileconst, maxWidth: mobileconst, fontSize: 20, borderRadius: 10, },
        })
    }, [wt])

    useEffect(() => {
        if (firsttime) {
            setSelectedtemplatetype(selectedTemplate)
            setLocalselectedtemplatetype(selectedtemplatetype)
            setSelectedlayout(heroimglayout)
            setFirsttime(false)
            props.updateOnceonlytemplatetype() // capture current selectedTemplate
        }
    }, [])

    useEffect(() => {
        if (selectedTemplate !== -1) {
            setSelectedtemplatetype(selectedTemplate)
            setSelectedlayout('single')
            setLocalselectedtemplatetype(selectedTemplate)
        }
    }, [selectedTemplate])

    useEffect(() => {
        setSelectedlayout(heroimglayout)
    }, [heroimglayout])

    const btmbarroot_css = {
        'MOBILE': { position: 'fixed', bottom: 0, left: 0, width: '100%' },
        'TABLET': { position: 'fixed', bottom: 0, left: 0, width: wt * 0.45 - 1 },
        'WEB': { position: 'fixed', bottom: 0, left: 0, width: wt * 0.45 - 1 }
    }[device]

    const revert = () => {
        setShowsave(false)
        restoreBackup()
        setPrebuildtemplatecolor({
            1: '',
            2: ''
        })
        setPrebuildindex({
            1: -1,
            2: -1
        })
    }
    const btmbar = <div className='iedit_swaproot' style={btmbarroot_css}>
        <button
            className='iedit_cancel'
            disabled={!showsave}
            style={{ opacity: !showsave ? 0.5 : 1 }}
            onClick={revert}>
            Revert
        </button>
        <button
            className='iedit_save'
            disabled={!showsave}
            style={{ opacity: !showsave ? 0.5 : 1 }}
            onClick={async () => {
                saveTemplates()
                    .then(() => {
                        clearBackup()
                        setShowsave(false)
                        setPrebuildtemplatecolor({
                            1: '',
                            2: ''
                        })
                        setPrebuildindex({
                            1: -1,
                            2: -1
                        })
                    })
            }}
        >
            Save
        </button>
    </div>


    const firsttemplate_old = <button
        style={
            wt > 547 && wt < TABLET
                ? {
                    minHeight: `calc( ${wt / 3}px - 20px )`,
                    minWidth: `calc( ${wt / 3}px - 20px )`,
                    maxHeight: `calc( ${wt / 3}px - 20px )`,
                    maxWidth: `calc( ${wt / 3}px - 20px )`,
                    fontSize: { 'WEB': 14, 'TABLET': 13, 'MOBILE': 14 }[device],
                    border: selectedtemplatetype === TEMPLATE_CARDPAGE ? selected_css : unselected_css,
                    borderRadius: 5,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'transparent',
                    pointer: 'cursor',
                    overflow: 'hidden'
                }
                : {
                    ...DEVICE_SIZE_MAP[device],
                    fontSize: { 'WEB': 14, 'TABLET': 13, 'MOBILE': 14 }[device],
                    border: selectedtemplatetype === TEMPLATE_CARDPAGE ? selected_css : unselected_css,
                    borderRadius: 5,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'transparent',
                    position: 'relative',
                    pointer: 'cursor',
                    overflow: 'hidden'
                }
        }
        value={1}
        onClick={() => {
            if (selectedTemplate === TEMPLATE_CARDPAGE) return;
            // setSelectedtemplatetype(TEMPLATE_CARDPAGE)
            // if (!showsave) { updateBackup(); setShowsave(true); }
            revert()
            // updateBackup(); 
            // if (props.styletype !== 'Empty' && !showsave) { updateBackup(); setShowsave(true); }
            updateTemplate(1)
        }}>
        <div style={{ transition: '.2s ease-in-out', transform: selectedtemplatetype === TEMPLATE_CARDPAGE ? 'scale(0.85)' : '', height: '100%', width: '100%', border: '1px solid var(--maindark)', borderRadius: 10, backgroundColor: 'white', justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column', }} >
            <div style={{ height: '55%', width: '90%', borderRadius: 10, backgroundColor: imagecolor, border: '1px solid var(--maindark)' }} />
        </div>
    </button>

    const secondtemplate_new = <button
        value={2}
        style={
            wt > 547 && wt < TABLET
                ? {
                    minHeight: `calc( ${wt / 3}px - 20px )`,
                    minWidth: `calc( ${wt / 3}px - 20px )`,
                    maxHeight: `calc( ${wt / 3}px - 20px )`,
                    maxWidth: `calc( ${wt / 3}px - 20px )`,
                    fontSize: { 'WEB': 14, 'TABLET': 13, 'MOBILE': 14 }[device],
                    border: selectedtemplatetype === TEMPLATE_FULLPAGE ? selected_css : unselected_css,
                    borderRadius: 5,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'transparent',
                    pointer: 'cursor',
                    overflow: 'hidden'
                }
                : {
                    ...DEVICE_SIZE_MAP[device],
                    fontSize: { 'WEB': 14, 'TABLET': 13, 'MOBILE': 14 }[device],
                    border: selectedtemplatetype === TEMPLATE_FULLPAGE ? selected_css : unselected_css,
                    borderRadius: 5,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'transparent',
                    position: 'relative',
                    pointer: 'cursor',
                    overflow: 'hidden'
                }
        }
        onClick={() => {
            if (selectedTemplate === TEMPLATE_FULLPAGE) return;
            // setSelectedtemplatetype(TEMPLATE_FULLPAGE)
            // if (!showsave) { updateBackup(); setShowsave(true); }
            revert()
            // updateBackup(); 
            // if (prebuildtemplatedesign_map[2]['styletype'] !== 'Empty' && !showsave) { updateBackup(); setShowsave(true); }
            updateTemplate(2)
        }}>
        <div
            style={{
                transition: '.2s ease-in-out', transform: selectedtemplatetype === TEMPLATE_FULLPAGE ? 'scale(0.85)' : '',
                height: '100%', width: '100%', borderRadius: 10, backgroundColor: 'white',
                justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column', placeContent: 'flex-start',
                overflow: 'hidden', position: 'relative',
            }}
        >
            <div style={{ position: 'absolute', left: 0, top: 0, height: '55%', width: '100%', borderRadius: '10px 10px 0px 0px', backgroundColor: imagecolor, border: '1px solid var(--maindark)' }} />
            <div style={{ position: 'absolute', left: 0, bottom: 0, height: '45%', width: '100%', borderRadius: '0px 0px 10px 10px', backgroundColor: 'white', border: '1px solid var(--maindark)', borderTop: 'none' }} />
        </div>
    </button>

    const firsttemplate = <button
        style={
            wt > 547 && wt < TABLET
                ? {
                    minHeight: `calc( ${wt / 3}px - 20px )`,
                    minWidth: `calc( ${wt / 3}px - 20px )`,
                    maxHeight: `calc( ${wt / 3}px - 20px )`,
                    maxWidth: `calc( ${wt / 3}px - 20px )`,
                    fontSize: { 'WEB': 14, 'TABLET': 13, 'MOBILE': 14 }[device],
                    border: localselectedtemplatetype === TEMPLATE_CARDPAGE ? selected_css : unselected_css,
                    borderRadius: 5,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'transparent',
                    pointer: 'cursor',
                    overflow: 'hidden'
                }
                : {
                    ...DEVICE_SIZE_MAP[device],
                    fontSize: { 'WEB': 14, 'TABLET': 13, 'MOBILE': 14 }[device],
                    border: localselectedtemplatetype === TEMPLATE_CARDPAGE ? selected_css : unselected_css,
                    borderRadius: 5,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'transparent',
                    position: 'relative',
                    pointer: 'cursor',
                    overflow: 'hidden'
                }
        }
        value={1}
        onClick={() => {
            setLocalselectedtemplatetype(1)
            setPrebuildtemplatecolor({
                1: '',
                2: '',
            })
            setPrebuildindex({
                1: -1, // templatetype : template selected index
                2: -1
            })
        }}
    >
        <div style={{ transition: '.2s ease-in-out', transform: localselectedtemplatetype === TEMPLATE_CARDPAGE ? 'scale(0.85)' : '', height: '100%', width: '100%', border: '1px solid var(--maindark)', borderRadius: 10, backgroundColor: 'white', justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column', }} >
            <div style={{ height: '55%', width: '90%', borderRadius: 10, backgroundColor: imagecolor, border: '1px solid var(--maindark)' }} />
        </div>
    </button>

    const secondtemplate = <button
        value={2}
        style={
            wt > 547 && wt < TABLET
                ? {
                    minHeight: `calc( ${wt / 3}px - 20px )`,
                    minWidth: `calc( ${wt / 3}px - 20px )`,
                    maxHeight: `calc( ${wt / 3}px - 20px )`,
                    maxWidth: `calc( ${wt / 3}px - 20px )`,
                    fontSize: { 'WEB': 14, 'TABLET': 13, 'MOBILE': 14 }[device],
                    border: localselectedtemplatetype === TEMPLATE_FULLPAGE ? selected_css : unselected_css,
                    borderRadius: 5,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'transparent',
                    pointer: 'cursor',
                    overflow: 'hidden'
                }
                : {
                    ...DEVICE_SIZE_MAP[device],
                    fontSize: { 'WEB': 14, 'TABLET': 13, 'MOBILE': 14 }[device],
                    border: localselectedtemplatetype === TEMPLATE_FULLPAGE ? selected_css : unselected_css,
                    borderRadius: 5,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'transparent',
                    position: 'relative',
                    pointer: 'cursor',
                    overflow: 'hidden'
                }
        }
        onClick={() => { setLocalselectedtemplatetype(2) }}
    >
        <div
            style={{
                transition: '.2s ease-in-out', transform: localselectedtemplatetype === TEMPLATE_FULLPAGE ? 'scale(0.85)' : '',
                height: '100%', width: '100%', borderRadius: 10, backgroundColor: 'white',
                justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column', placeContent: 'flex-start',
                overflow: 'hidden', position: 'relative',
            }}
        >
            <div style={{ position: 'absolute', left: 0, top: 0, height: '55%', width: '100%', borderRadius: '10px 10px 0px 0px', backgroundColor: imagecolor, border: '1px solid var(--maindark)' }} />
            <div style={{ position: 'absolute', left: 0, bottom: 0, height: '45%', width: '100%', borderRadius: '0px 0px 10px 10px', backgroundColor: 'white', border: '1px solid var(--maindark)', borderTop: 'none' }} />
        </div>
    </button>

    const cropcomplete = useCallback((croppedArea, croppedAreaPixels) => {
        setTempcroppedimg(croppedAreaPixels)
    }, [])

    const cropcancel = () => {
        setTempmainimg(null)
        setTempmainimginfo(null)
        setTempcroppedimg(null)
        setNeededit(false)
    }

    function uploadtobackend(data) {
        axios({
            method: 'POST',
            url: INVITATION_SAVEHEROIMGS,
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data' }, // need token from the web
            data: data
        }).then((item) => {
            const { message, thumbnail, img } = item.data
            if (message === 'SUCCESS') {
                updateheroimgobj(thumbnail, img, heroimgarrposition, selectedlayout, selectedtemplatetype)
                console.log('tempmainimginfo', tempmainimginfo)
                // bug
                setStatus('Uploading ' + tempmainimginfo['name'][0])

                setTimeout(() => {
                    setTempmainimg(null)
                    setTempmainimginfo(null)
                    setTempcroppedimg(null)
                    setStatus('')
                    setNeededit(false)
                    setUploadstate('WAITING')
                }, 1000)

                if (showsave) {
                    saveTemplates().then(() => {
                        clearBackup()
                        setShowsave(false)
                        setPrebuildtemplatecolor({
                            1: '',
                            2: ''
                        })
                        setPrebuildindex({
                            1: -1,
                            2: -1
                        })
                    })
                }
            }
            else if (message === 'INCORRECTFILETYPE') {
                setStatus('Incorrect File Type.')
                setTimeout(() => { setStatus('') }, 1000)
            }
            else if (message === 'NOSUCHIC') {
                setStatus('Invitation Does Not Exist.')
                setTimeout(() => { setStatus('') }, 1000)
            }
            else if (message === 'REACHQUOTA') {
                setStatus('Reach Max Quota.')
                setTimeout(() => { setStatus('') }, 1000)
            }
        })
    }

    // bull
    const editupload = async () => {
        setUploadstate('UPLOADING')
        const croppedImage = await getCroppedImg(tempmainimg, tempcroppedimg)
        if (croppedImage) {
            const { type } = tempmainimginfo
            var data = new FormData()
            croppedImage.toBlob((blob) => {
                var curr_img = new File( // reconstruct image
                    [blob],
                    urlhandler + '.' + type[0].split('/')[1],
                    { type: 'image/' + type[0].split('/')[1] }
                )
                var curr_thumbnail = new File( // reconstruct image
                    [dataURLToBlob(tempmainimgsmall[0])],
                    urlhandler + 'thumbnail.' + type[0].split('/')[1],
                    { type: type[0] }
                )

                data.append('urlhandler', urlhandler)
                data.append('id', invitation_id)
                data.append('img', curr_img)
                data.append('img', curr_thumbnail)
                data.append('heroimgarrposition', heroimgarrposition)
                data.append('selectedtemplatetype', selectedtemplatetype)
                data.append('selectedlayout', selectedlayout)

                uploadtobackend(data)

            }, 'image/jpeg');
        }
    }

    // bear
    const withouteditupload = (tempmainimginfo, tempmainimg, tempmainimgsmall) => {
        setUploadstate('UPLOADING')
        console.log('tempmainimgsmall', tempmainimgsmall)
        if (tempmainimgsmall.length > 0) {
            var data = new FormData()

            var curr_img = new File( // reconstruct image
                tempmainimg,
                urlhandler + '.' + tempmainimginfo['type'][0].split('/')[1],
                { type: 'image/' + tempmainimginfo['type'][0].split('/')[1] }
            )
            var curr_thumbnail = new File( // reconstruct image
                [dataURLToBlob(tempmainimgsmall[0])],
                urlhandler + 'thumbnail.' + tempmainimginfo['type'][0].split('/')[1],
                { type: tempmainimginfo['type'][0] }
            )

            data.append('urlhandler', urlhandler)
            data.append('id', invitation_id)
            data.append('img', curr_thumbnail)
            data.append('img', curr_img)
            data.append('heroimgarrposition', heroimgarrposition)
            data.append('selectedtemplatetype', selectedtemplatetype)
            data.append('selectedlayout', selectedlayout)

            uploadtobackend(data)
        }


    }

    const updateAnimationmode = (e) => {
        if (!showsave) { updateBackup(); setShowsave(true) }

        const { value } = e.target
        let new_heroimgattr_map = JSON.parse(JSON.stringify(heroimgattr_map))
        new_heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['mode'] = parseInt(value)
        updateHeroimgattrmap(new_heroimgattr_map)
    }

    const updateAnimatingspeed = (e) => {
        if (!showsave) { updateBackup(); setShowsave(true) }

        const { value } = e.target
        let new_heroimgattr_map = JSON.parse(JSON.stringify(heroimgattr_map))
        new_heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['speed'] = parseInt(value)
        updateHeroimgattrmap(new_heroimgattr_map)
    }

    const updateColor = (c) => {
        if (!showsave) { updateBackup(); setShowsave(true) }
        let new_heroimgattr_map = JSON.parse(JSON.stringify(heroimgattr_map))
        new_heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['color'] = c
        updateHeroimgattrmap(new_heroimgattr_map)
    }

    const updateThickness = (e) => {
        if (!showsave) { updateBackup(); setShowsave(true) }
        const { value } = e.target
        let new_heroimgattr_map = JSON.parse(JSON.stringify(heroimgattr_map))
        new_heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['sw'] = parseInt(value)
        updateHeroimgattrmap(new_heroimgattr_map)
    }

    const updatePosition = (e) => {
        if (!showsave) { setShowsave(true); updateBackup(); }
        const { value } = e.target
        let new_heroimgattr_map = JSON.parse(JSON.stringify(heroimgattr_map))
        new_heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['svgposition'] = parseInt(value)
        updateHeroimgattrmap(new_heroimgattr_map)
    }

    const updateSvganimation = (value) => {
        if (!showsave) { updateBackup(); setShowsave(true) }
        let new_heroimgattr_map = JSON.parse(JSON.stringify(heroimgattr_map))
        new_heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['svgitem'] = value
        updateHeroimgattrmap(new_heroimgattr_map)
    }

    const updateReplay = () => {
        if (!showsave) { updateBackup(); setShowsave(true) }
        let new_heroimgattr_map = JSON.parse(JSON.stringify(heroimgattr_map))
        new_heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['replay'] = !new_heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['replay']
        updateHeroimgattrmap(new_heroimgattr_map)
    }

    const updateBoxshadow = () => {
        if (!showsave) { updateBackup(); setShowsave(true) }
        let new_heroimgattr_map = JSON.parse(JSON.stringify(heroimgattr_map))
        new_heroimgattr_map[selectedtemplatetype]['css_map']['boxShadow'] = !new_heroimgattr_map[selectedtemplatetype]['css_map']['boxShadow']
        updateHeroimgattrmap(new_heroimgattr_map)
    }

    const updateCorner = () => {
        if (!showsave) { updateBackup(); setShowsave(true) }
        let new_heroimgattr_map = JSON.parse(JSON.stringify(heroimgattr_map))
        new_heroimgattr_map[selectedtemplatetype]['css_map']['borderRadius'] = !new_heroimgattr_map[selectedtemplatetype]['css_map']['borderRadius']
        updateHeroimgattrmap(new_heroimgattr_map)
    }

    const updateWebimgconstant = (e) => {
        if (!showsave) { updateBackup(); setShowsave(true) }
        let new_heroimgattr_map = JSON.parse(JSON.stringify(heroimgattr_map))
        new_heroimgattr_map[selectedtemplatetype]['css_map']['webimgconstant'] = Number(e.target.value)
        updateHeroimgattrmap(new_heroimgattr_map)
    }

    const updateTabletimgconstant = (e) => {
        if (!showsave) { updateBackup(); setShowsave(true) }
        let new_heroimgattr_map = JSON.parse(JSON.stringify(heroimgattr_map))
        new_heroimgattr_map[selectedtemplatetype]['css_map']['tabletimgconstant'] = Number(e.target.value)
        updateHeroimgattrmap(new_heroimgattr_map)
    }

    const selectTemplate = (templatetype, templateindex) => {
        if (!showsave) { updateBackup(); setShowsave(true); }
        updateTemplate(localselectedtemplatetype)


        const templateobj = localselectedtemplatetype === 1 ? prebuilttemplatest1[templateindex] : prebuilttemplatest2[templateindex]

        const local_templatecolor = templateobj.templatecolors[0]
        setPrebuildtemplatecolor((currprebuildtemplatecolor) => {
            let new_currprebuildtemplatecolor = JSON.parse(JSON.stringify(currprebuildtemplatecolor))
            new_currprebuildtemplatecolor[localselectedtemplatetype] = local_templatecolor
            return new_currprebuildtemplatecolor
        })
        const specific_data = templateobj['templatecolors_data_map'][local_templatecolor]
        const common_data = templateobj['common_data']

        const svgoverlay_map = templateobj['svgoverlay_map'][local_templatecolor]

        setPrebuildindex((currprebuildindex) => {
            let new_currprebuildindex = JSON.parse(JSON.stringify(currprebuildindex))
            new_currprebuildindex[localselectedtemplatetype] = templateindex
            return new_currprebuildindex
        })

        const combined_data = { ...specific_data, ...common_data, svgoverlay_map: svgoverlay_map, templatetype: localselectedtemplatetype }

        if (localselectedtemplatetype === 1) {
            updatePrebuilttemplateT1(combined_data)
        }
        else if (localselectedtemplatetype === 2) {
            updatePrebuilttemplateT2(combined_data)
        }

        updateTemplateattrmap(local_templatecolor, localselectedtemplatetype)

    }

    const selectTemplatecolor = (templatetype, templateindex, local_templatecolor) => {
        if (!showsave) { updateBackup(); setShowsave(true); }
        updateTemplate(localselectedtemplatetype)


        const templateobj = templatetype === 1 ? prebuilttemplatest1[templateindex] : prebuilttemplatest2[templateindex]

        setPrebuildtemplatecolor((currprebuildtemplatecolor) => {
            let new_currprebuildtemplatecolor = JSON.parse(JSON.stringify(currprebuildtemplatecolor))
            new_currprebuildtemplatecolor[templatetype] = local_templatecolor
            return new_currprebuildtemplatecolor
        })

        const specific_data = templateobj['templatecolors_data_map'][local_templatecolor]
        const common_data = templateobj['common_data']

        const svgoverlay_map = templateobj['svgoverlay_map'][local_templatecolor]

        setPrebuildindex((currprebuildindex) => {
            let new_currprebuildindex = JSON.parse(JSON.stringify(currprebuildindex))
            new_currprebuildindex[templatetype] = templateindex
            return new_currprebuildindex
        })


        const combined_data = { ...specific_data, ...common_data, svgoverlay_map: svgoverlay_map, templatetype: localselectedtemplatetype }
        if (localselectedtemplatetype === 1) {
            updatePrebuilttemplateT1(combined_data)
        }
        else if (localselectedtemplatetype === 2) {
            updatePrebuilttemplateT2(combined_data)
        }


        updateTemplateattrmap(local_templatecolor, localselectedtemplatetype)
    }

    return {
        '': <div className="Ieditcomp_div" style={{ ...firsttimeenter ? firsttimeenter_commoneditstyle : commoneditstyle, overflowY: 'auto' }}>

            <Explain title={TITLE} txt={TEXT} />

            <div className='Details_grp'>
                {partialtitle_dom('Template Style', {})}
                {inputdescribe_dom('Change of template, click to select.')}
                {INVITATIONTYPES_ARR.includes(itype) > 0
                    ? <div className={`Imageinvitationcard_root${device}`} style={{ flexDirection: 'column', padding: 0 }}>
                        {firsttemplate}
                        {secondtemplate}
                    </div>
                    : null}
            </div>

            {DEVICE_SIZE_MAP && Object.keys(DEVICE_SIZE_MAP).length > 0
                ? <div className='Details_grp'>
                    {partialtitle_dom('Pre-Built Template', {})}
                    {inputdescribe_dom(`Get started by choosing a pre-built for your ${itype} website! You can switch to a new template at any time.`)}
                    <div
                        style={
                            wt < 420
                                ? { display: 'flex', flexDirection: 'column', }
                                : {
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit,  calc( 50% - 2px ) )',
                                    gridGap: 3
                                }}
                    >
                        {{
                            1: prebuilttemplatest1.map((item, index) => {
                                const { templatecolors, name, templatecolors_img_map } = item

                                const tickicon_css = { width: 15, height: 15, display: 'flex', alignItems: 'center', margin: '0px 5px 0px 0px', }
                                const check_index = prebuildindex[1] === index
                                return <div key={index + 'item'} style={{ border: check_index ? '3px solid var(--mainpink)' : '3px solid white', display: 'flex', placeContent: 'flex-start', width: '100%', flexDirection: 'column', padding: 10, borderRadius: 5, boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 0px 1px inset' }} >

                                    <button
                                        value={index}
                                        onClick={() => selectTemplate(1, index)}
                                        style={{ border: 'none', display: 'flex', flexDirection: 'column', backgroundColor: '#ffffff', padding: 0 }}
                                    >
                                        <div style={{ padding: '5px 0px 15px', width: '100%', textAlign: 'center', placeContent: 'center' }}>{name}</div>
                                        <img
                                            src={(prebuildtemplatecolor[1] === '' || prebuildindex[1] !== index) ? templatecolors_img_map[templatecolors[0]] : templatecolors_img_map[prebuildtemplatecolor[1]]}
                                            style={{ width: '100%', objectFit: 'contain', backgroundColor: 'white', border: '1px solid var(--lightdark)' }}
                                        />
                                    </button>

                                    <ul style={{ padding: '15px 0px 0px 0px', margin: 0, display: 'flex', listStyle: 'none', flexWrap: 'wrap', gridGap: 3, gap: 3, overflow: 'auto', placeContent: 'flex-start' }}>
                                        {templatecolors
                                            ? templatecolors.map((c, i) => {
                                                return <div
                                                    key={i + 'color1'}
                                                    style={{ border: (check_index && prebuildtemplatecolor[1] === c) ? '2px solid var(--mainpink)' : '2px solid transparent', padding: 1, width: 'max-content', height: 'max-content', display: 'flex', placeContent: 'center', alignItems: 'center', borderRadius: 5 }}>
                                                    <li
                                                        style={{ border: (check_index && prebuildtemplatecolor[1] === c) ? 'none' : '1px solid var(--lightdark)', backgroundColor: c, width: 20, height: 20, cursor: 'pointer', borderRadius: 3, }}
                                                        onClick={() => selectTemplatecolor(1, index, c)}
                                                    />
                                                </div>
                                            })
                                            : null}
                                    </ul>

                                    <div style={{ display: 'flex', placeContent: 'flex-end', marginTop: 15, display: 'flex', flexDirection: 'column' }}>
                                        <button style={{ margin: 0, padding: '0px', width: 'max-content', border: '1px solid transparent', borderRadius: 10, display: 'flex', alignContent: 'center', placeContent: 'center', backgroundColor: '#ffffff', alignItems: 'center' }}>{iconwrapper(TICK_ICON, tickicon_css)} Seat Chart </button>
                                        <button style={{ margin: 0, padding: '0px', width: 'max-content', border: '1px solid transparent', borderRadius: 10, display: 'flex', alignContent: 'center', placeContent: 'center', backgroundColor: '#ffffff', alignItems: 'center' }}>{iconwrapper(TICK_ICON, tickicon_css)} Itinerary</button>
                                        {/* <button style={{ margin: 0, padding: '0px', width: 'max-content', border: '1px solid transparent', borderRadius: 10, display: 'flex', alignContent: 'center', placeContent: 'center', backgroundColor: '#ffffff', alignItems: 'center' }}>{iconwrapper(TICK_ICON, tickicon_css)} Table Card </button> */}
                                        {/* <button style={{ margin: '20px 0px 0px 0px', padding: '0px 10px', width: 'max-content', border: 'thin solid var(--maindark)', borderRadius: 10, display: 'flex', alignContent: 'center', placeContent: 'center', backgroundColor: '#ffffff', placeSelf: 'flex-end' }}>Matching Prints</button> */}
                                    </div>

                                </div>

                            }),
                            2: prebuilttemplatest2.map((item, index) => {
                                const { name, templatecolors, templatecolors_img_map } = item

                                const tickicon_css = { width: 15, height: 15, display: 'flex', alignItems: 'center', margin: '0px 5px 0px 0px', }
                                const check_index = prebuildindex[2] === index
                                return <div key={index + 'item'} style={{ border: check_index ? '3px solid var(--mainpink)' : '3px solid white', display: 'flex', placeContent: 'flex-start', width: '100%', flexDirection: 'column', padding: 10, borderRadius: 5, boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 0px 1px inset' }} >

                                    <button
                                        value={index}
                                        onClick={() => selectTemplate(2, index)}
                                        style={{ border: 'none', display: 'flex', flexDirection: 'column', backgroundColor: '#ffffff', padding: 0 }}
                                    >
                                        <div style={{ padding: '5px 0px 15px', width: '100%', textAlign: 'center', placeContent: 'center' }}>{name}</div>
                                        <img
                                            src={(prebuildtemplatecolor[2] === '' || prebuildindex[2] !== index) ? templatecolors_img_map[templatecolors[0]] : templatecolors_img_map[prebuildtemplatecolor[2]]}
                                            style={{ width: '100%', objectFit: 'contain', backgroundColor: 'white', border: '1px solid var(--lightdark)' }}
                                        />
                                    </button>

                                    <ul style={{ padding: '15px 0px 0px 0px', margin: 0, display: 'flex', listStyle: 'none', flexWrap: 'wrap', gridGap: 3, gap: 3, overflow: 'auto', placeContent: 'flex-start' }}>
                                        {templatecolors
                                            ? templatecolors.map((c, i) => {
                                                return <div
                                                    key={i + 'color1'}
                                                    style={{ border: (check_index && prebuildtemplatecolor[2] === c) ? '2px solid var(--mainpink)' : '2px solid transparent', padding: 1, width: 'max-content', height: 'max-content', display: 'flex', placeContent: 'center', alignItems: 'center', borderRadius: 5 }}>
                                                    <li
                                                        style={{ border: (check_index && prebuildtemplatecolor[2] === c) ? 'none' : '1px solid var(--lightdark)', backgroundColor: c, width: 20, height: 20, cursor: 'pointer', borderRadius: 3, }}
                                                        onClick={() => selectTemplatecolor(2, index, c)}
                                                    />
                                                </div>
                                            })
                                            : null}
                                    </ul>

                                    <div style={{ display: 'flex', placeContent: 'flex-end', marginTop: 15, display: 'flex', flexDirection: 'column' }}>
                                        <button style={{ margin: 0, padding: '0px', width: 'max-content', border: '1px solid transparent', borderRadius: 10, display: 'flex', alignContent: 'center', placeContent: 'center', backgroundColor: '#ffffff', alignItems: 'center' }}>{iconwrapper(TICK_ICON, tickicon_css)} Seat Chart </button>
                                        <button style={{ margin: 0, padding: '0px', width: 'max-content', border: '1px solid transparent', borderRadius: 10, display: 'flex', alignContent: 'center', placeContent: 'center', backgroundColor: '#ffffff', alignItems: 'center' }}>{iconwrapper(TICK_ICON, tickicon_css)} Itinerary</button>
                                        {/* <button style={{ margin: 0, padding: '0px', width: 'max-content', border: '1px solid transparent', borderRadius: 10, display: 'flex', alignContent: 'center', placeContent: 'center', backgroundColor: '#ffffff', alignItems: 'center' }}>{iconwrapper(TICK_ICON, tickicon_css)} Table Card </button> */}
                                        {/* <button style={{ margin: '20px 0px 0px 0px', padding: '0px 10px', width: 'max-content', border: 'thin solid var(--maindark)', borderRadius: 10, display: 'flex', alignContent: 'center', placeContent: 'center', backgroundColor: '#ffffff', placeSelf: 'flex-end' }}>Matching Prints</button> */}
                                    </div>

                                </div>

                            })
                        }[localselectedtemplatetype]}

                    </div>
                </div>
                : null}

            {btmbar}

            {neededit
                ? <div className="Imageic_croproot">
                    <div className="Imageic_cropcontainer">
                        <Cropper
                            image={tempmainimg}
                            crop={crop}
                            zoom={zoom}
                            aspect={ILOOKUPTEMPLATESINFO_MAP[selectedtemplatetype][selectedlayout]['img_edit']['aspectratio']}
                            onCropChange={setCrop}
                            onZoomChange={setZoom}
                            onCropComplete={cropcomplete}
                        />
                        <div className="Imageic_btnsrow">
                            {uploadstate === 'WAITING'
                                ? <button key={'imgs_cancel_' + uploadstate} className="Imageic_btn" onClick={cropcancel}>
                                    Cancel
                                </button>
                                : null}
                            {uploadstate === 'UPLOADING'
                                ? <div className="Imageic_uploading" >
                                    ...
                                </div>
                                : null}
                            {uploadstate === 'WAITING'
                                ? <button key={'imgs_upload_' + uploadstate} onClick={editupload} className="Imageic_btn" style={{ marginRight: 5 }} disabled={uploadstate === 'UPLOADING'}>
                                    Upload
                                </button>
                                : null}
                        </div>
                    </div>
                </div>
                : null
            }

            <Noti noti={status} />
            <Noti noti={error} />

            {cfmdel // for deleting image
                ? <Modcfm
                    onHide={() => { setCfmdel(false) }}
                    onOk={async () => {
                        setCfmdel(false)
                        delsingleheroimgobj(selectedtemplatetype, selectedlayout, deleteimgposition)
                            .then((message) => {
                                const { result, msg } = message
                                if (result && msg === 'Saved') {
                                    setDeleteimgposition(-1)
                                }
                            })
                            .catch(e => {
                                console.log('e', e)
                            })
                    }}
                    onNo={() => {
                        setCfmdel(false)
                    }}
                    txt={'Once you delete this, there is no going back. Please be certain.'}
                />
                : null}
        </div>,
        'Hero Image Effect & Style': (heroimgattr_map && heroimgattr_map[selectedtemplatetype])
            ? <div id="Ieditcomp_root">
                <div id="Ieditcomp_contentroot">
                    <Highlighttitle
                        icon={null}
                        onClick={() => {
                            updateSubpageback();
                        }}
                        selectedsubpage={selectedsubpage}
                    />
                    <div className='Ieditcomp_div' style={homeimageeffectstyle_commoneditstyle}>

                        {/* Animated Layer */}
                        <div className="Details_grp">
                            {partialtitle_dom('Animated Layer', {})}
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <button
                                    value={0}
                                    onClick={() => updateSvganimation(0)}
                                    className={`Images_firstsvg ${heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['svgitem'] === 0 ? 'Images_borderselected' : ''}`}
                                    style={{
                                        borderBottom: heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['svgitem'] === 1
                                            ? 'none'
                                            : heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['svgitem'] === 0
                                                ? '3px solid var(--mainpink)'
                                                : '1px solid var(--subgrey)'
                                    }}
                                >
                                    <div className="Images_svgtxt">Empty</div>
                                </button>
                                <button
                                    value={1}
                                    onClick={() => updateSvganimation(1)}
                                    className={`Images_midsvg ${heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['svgitem'] === 1 ? 'Images_borderselected' : ''}`}
                                    style={{
                                        borderTop: heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['svgitem'] === 0
                                            ? 'none'
                                            : heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['svgitem'] === 1
                                                ? '3px solid var(--mainpink)'
                                                : 'none',
                                        borderBottom: heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['svgitem'] === 2
                                            ? 'none'
                                            : heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['svgitem'] === 1
                                                ? '3px solid var(--mainpink)'
                                                : 'none',
                                    }}
                                >
                                    <svg className='Images_svgitem' width="100%" height="100%" viewBox="0 0 5030 1032" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        {WEDO_PATH}
                                    </svg>
                                    <div className="Images_svgtxt">We Do</div>
                                </button>
                                <button
                                    value={2}
                                    onClick={() => updateSvganimation(2)}
                                    className={`Images_secondsvg ${heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['svgitem'] === 2 ? 'Images_borderselected' : ''}`}
                                    style={{
                                        borderTop: heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['svgitem'] === 1
                                            ? 'none'
                                            : heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['svgitem'] === 2
                                                ? '3px solid var(--mainpink)'
                                                : '1px solid var(--subgrey)'
                                    }}
                                >
                                    <svg className='Images_svgitem' width="100%" height="100%" viewBox="0 0 5030 1032" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                        {HEART_PATH}
                                    </svg>
                                    <div className="Images_svgtxt">Heart</div>
                                </button>

                            </div>
                        </div>

                        {/* Animated Text Color */}
                        <div className="Details_grp">
                            {partialtitle_dom('Animated Text Color', {})}
                            {inputdescribe_dom(`Color of animated text. `)}
                            <div className='Detailsfont_container'>
                                <div className='Detailsfont_left'>
                                    <HexColorPicker style={{ height: 200, width: 200 }} color={heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['color']} onChange={updateColor} />
                                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10, alignItems: 'center' }}>
                                        <div style={{ paddingRight: 3, fontSize: 18 }}>#</div>
                                        <HexColorInput color={heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['color']} onChange={updateColor} style={{ width: '100%', borderRadius: 8, padding: '3px 5px', border: '1px solid var(--maindark)' }} />
                                    </div>
                                </div>
                                <ul className='Detailsfont_right'>
                                    {colors_arr.map((c, i) => {
                                        return <div key={i + 'color1'} style={{ padding: 1, width: 'max-content', height: 'max-content', display: 'flex', placeContent: 'center', alignItems: 'center', border: heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['color'] === c ? '3px solid var(--mainpink)' : '3px solid transparent', borderRadius: 5 }}>
                                            <li style={{ width: 20, height: 20, backgroundColor: c, border: 'none', cursor: 'pointer', borderRadius: 3, border: heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['color'] === c ? 'none' : '1px solid var(--lightdark)' }} onClick={() => updateColor(c)} />
                                        </div>
                                    })}
                                </ul>
                            </div>
                        </div>

                        {/* Animated Text Animation Mode */}
                        <div className="Details_grp">
                            {partialtitle_dom('Animated Text Animation Mode', {})}
                            {inputdescribe_dom(`Animation state of animated text.`)}
                            <div className='Images_animateselectroot'>
                                <button className={`Images_animatestate ${heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['mode'] === 0 ? 'Images_selected' : 'Images_selectednone'}`} value={0} onClick={updateAnimationmode}>Static</button>
                                <button className={`Images_animatestate ${heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['mode'] === 1 ? 'Images_selected' : 'Images_selectednone'}`} value={1} onClick={updateAnimationmode}>Entrance Animation</button>
                                <button className={`Images_animatestate ${heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['mode'] === 2 ? 'Images_selected' : 'Images_selectednone'}`} value={2} onClick={updateAnimationmode}>Infinite Animation</button>
                            </div>
                        </div>

                        {/* Animating speed */}
                        <div className="Details_grp">
                            {partialtitle_dom('Animating speed ', {})}
                            {inputdescribe_dom(`Speed of animating text`)}
                            <div className='Images_animateselectroot'>
                                <button className={`Images_animatestate Images_animateht ${heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['speed'] === 0 ? 'Images_selected' : 'Images_selectednone'}`} value={0} onClick={updateAnimatingspeed}>Slow</button>
                                <button className={`Images_animatestate Images_animateht ${heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['speed'] === 1 ? 'Images_selected' : 'Images_selectednone'}`} value={1} onClick={updateAnimatingspeed}>Medium</button>
                                <button className={`Images_animatestate Images_animateht ${heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['speed'] === 2 ? 'Images_selected' : 'Images_selectednone'}`} value={2} onClick={updateAnimatingspeed}>Fast</button>
                            </div>
                        </div>

                        {/* Animated Text Thickness */}
                        <div className="Details_grp">
                            {partialtitle_dom('Animated Text Thickness', {})}
                            {inputdescribe_dom(`Select the thickness level of animated text.`)}
                            <div className='Images_animateselectroot'>
                                <button className={`Images_animatestate Images_animateht ${heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['sw'] === 15 ? 'Images_selected' : 'Images_selectednone'}`} value={15} onClick={updateThickness}>Thin</button>
                                <button className={`Images_animatestate Images_animateht ${heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['sw'] === 30 ? 'Images_selected' : 'Images_selectednone'}`} value={30} onClick={updateThickness}>Thick</button>
                                <button className={`Images_animatestate Images_animateht ${heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['sw'] === 45 ? 'Images_selected' : 'Images_selectednone'}`} value={45} onClick={updateThickness}>Thicker</button>
                            </div>
                        </div>

                        {/* Animated Text Position */}
                        <div className="Details_grp">
                            {partialtitle_dom('Animated Text Position', {})}
                            {inputdescribe_dom(`Position of animated text.`)}
                            <div className='Images_animateselectroot'>
                                <button className={`Images_animatestate Images_animateht ${heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['svgposition'] === 0 ? 'Images_selected' : 'Images_selectednone'}`} value={0} onClick={updatePosition}>Top</button>
                                <button className={`Images_animatestate Images_animateht ${heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['svgposition'] === 1 ? 'Images_selected' : 'Images_selectednone'}`} value={1} onClick={updatePosition}>Center</button>
                                <button className={`Images_animatestate Images_animateht ${heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['svgposition'] === 2 ? 'Images_selected' : 'Images_selectednone'}`} value={2} onClick={updatePosition}>Bottom</button>
                            </div>
                        </div>

                        {/* Replay Button */}
                        <div className='Details_grp'>
                            {partialtitle_dom('Replay Button', {})}
                            {inputdescribe_dom(`On to allow user to replay animated text vice versa. Only available on "Infinite" mode.`)}
                            {radiobtn_dom(
                                heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['replay'] ? true : false,
                                updateReplay,
                                heroimgattr_map[selectedtemplatetype]['svgoverlay_map']['replay'] ? `Replay Enabled` : `Replay Disabled`,
                                { margin: 0 }
                            )}
                        </div>

                        {/* Box-shadow for Main Image */}
                        <div className='Details_grp'>
                            {partialtitle_dom('Box-shadow for Main Image', {})}
                            {inputdescribe_dom(`On box-shadow for your main image vice versa`)}
                            {radiobtn_dom(
                                heroimgattr_map[selectedtemplatetype]['css_map']['boxShadow'] ? true : false,
                                updateBoxshadow,
                                heroimgattr_map[selectedtemplatetype]['css_map']['boxShadow'] ? `Box-shadow Enabled` : `Box-shadow Disabled`,
                                { margin: 0 }
                            )}
                        </div>

                        {/* Corner for main image */}
                        <div className='Details_grp'>
                            {partialtitle_dom('Corner for main image', {})}
                            {inputdescribe_dom(`Select type of corner for your image`)}
                            {radiobtn_dom(
                                heroimgattr_map[selectedtemplatetype]['css_map']['borderRadius'] ? true : false,
                                updateCorner,
                                heroimgattr_map[selectedtemplatetype]['css_map']['borderRadius'] ? `Round Corner Enabled` : `Round Corner Disabled`,
                                { margin: 0 }
                            )}
                        </div>

                        {/* Image Size */}
                        <div className='Details_grp'>
                            {partialtitle_dom('Image Size', {})}
                            {inputdescribe_dom(`Adjust the image size based on different devices`)}
                            <div style={{ display: 'flex', flexDirection: 'row', marginTop: 5 }}>
                                <button
                                    className={`Details_settingbtn ${selecteddevice === 0 ? 'Details_selectedbtn' : selecteddevice !== -1 ? 'Details_selectednone' : ''}`}
                                    value={0}
                                    onClick={(e) => { setSelecteddevice(parseInt(e.target.value)) }}
                                >
                                    {iconwrapper(LAPTOP_ICON, { width: 27, height: 27, })}
                                    <div>Desktop</div>
                                </button>
                                <button
                                    className={`Details_settingbtn ${selecteddevice === 1 ? 'Details_selectedbtn' : selecteddevice !== -1 ? 'Details_selectednone' : ''}`}
                                    value={1}
                                    onClick={(e) => { setSelecteddevice(parseInt(e.target.value)) }}
                                >
                                    {iconwrapper(TABLET_ICON, { width: 27, height: 27, })}
                                    <div>Tablet</div>
                                </button>
                            </div>
                            {[
                                // WEB
                                <div className='Details_lineacontainer' style={{ marginBottom: 0, padding: 10 }}>
                                    <button
                                        className={`Images_sizebtn${heroimgattr_map[selectedtemplatetype]['css_map']['webimgconstant'] === 0.8 ? 'shaded' : ''}`}
                                        value={0.8}
                                        onClick={updateWebimgconstant}
                                    >
                                        Small
                                    </button>
                                    <button
                                        className={`Images_sizebtn${heroimgattr_map[selectedtemplatetype]['css_map']['webimgconstant'] === 0.9 ? 'shaded' : ''}`}
                                        value={0.9}
                                        onClick={updateWebimgconstant}
                                    >
                                        Medium
                                    </button>
                                    <button
                                        className={`Images_sizebtn${heroimgattr_map[selectedtemplatetype]['css_map']['webimgconstant'] === 1 ? 'shaded' : ''}`}
                                        value={1}
                                        onClick={updateWebimgconstant}
                                    >
                                        Large
                                    </button>
                                </div>,
                                // TABLET
                                <div className='Details_lineacontainer' style={{ marginBottom: 0, padding: 10 }}>
                                    <button
                                        className={`Images_sizebtn${heroimgattr_map[selectedtemplatetype]['css_map']['tabletimgconstant'] === 0.8 ? 'shaded' : ''}`}
                                        value={0.8}
                                        onClick={updateTabletimgconstant}
                                    >
                                        Small
                                    </button>
                                    <button
                                        className={`Images_sizebtn${heroimgattr_map[selectedtemplatetype]['css_map']['tabletimgconstant'] === 0.9 ? 'shaded' : ''}`}
                                        value={0.9}
                                        onClick={updateTabletimgconstant}
                                    >
                                        Medium
                                    </button>
                                    <button
                                        className={`Images_sizebtn${heroimgattr_map[selectedtemplatetype]['css_map']['tabletimgconstant'] === 1 ? 'shaded' : ''}`}
                                        value={1}
                                        onClick={updateTabletimgconstant}
                                    >
                                        Large
                                    </button>
                                </div>
                            ][selecteddevice]}
                        </div>

                        {btmbar}

                    </div>
                </div>
            </div>
            : null

    }[selectedsubpage]
}

export default Templates